import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6 col-xxl-4" }
const _hoisted_3 = { class: "col-lg-6 col-xxl-4" }
const _hoisted_4 = { class: "col-lg-6 col-xxl-4" }
const _hoisted_5 = { class: "col-lg-6 overflow-hidden" }
const _hoisted_6 = { class: "col-lg-6 overflow-hidden" }
const _hoisted_7 = { class: "col-lg-6 overflow-hidden" }
const _hoisted_8 = { class: "col-lg-6 overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SingleUserExample = _resolveComponent("SingleUserExample")!
  const _component_GroupUserExample = _resolveComponent("GroupUserExample")!
  const _component_SingleUserWithBadgeExample = _resolveComponent("SingleUserWithBadgeExample")!
  const _component_AvatarSizeRoundedCircleExample = _resolveComponent("AvatarSizeRoundedCircleExample")!
  const _component_AvatarSizeSimpleRoundedExample = _resolveComponent("AvatarSizeSimpleRoundedExample")!
  const _component_TextAvatarSizeRoundedCircleExample = _resolveComponent("TextAvatarSizeRoundedCircleExample")!
  const _component_TextAvatarSizeSimpleRoundedExample = _resolveComponent("TextAvatarSizeSimpleRoundedExample")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SingleUserExample)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_GroupUserExample)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_SingleUserWithBadgeExample)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_AvatarSizeRoundedCircleExample)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_AvatarSizeSimpleRoundedExample)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_TextAvatarSizeRoundedCircleExample)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_TextAvatarSizeSimpleRoundedExample)
    ])
  ]))
}